import { render, staticRenderFns } from "./KnowledgeBaseHint.vue?vue&type=template&id=0dc0b0e8&scoped=true"
import script from "./KnowledgeBaseHint.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBaseHint.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeBaseHint.vue?vue&type=style&index=0&id=0dc0b0e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc0b0e8",
  null
  
)

export default component.exports